export default "__VITE_ASSET__YPebhtdt__"